import { TickerChipCell, TextCell } from "../cells";

export const tickerColumn = {
  width: "1fr",
  label: <TextCell>Ticker</TextCell>,
  cell: (event: { securities: { ticker: string }[] }) => (
    <TickerChipCell securities={event.securities} />
  ),
};
